import { FC } from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';

import './SCUITabs.scss';
import Helper from '../../../utils/helper';
import { Box } from '@mui/material';

interface ITab {
    id: number;
    name: string;
    activeIcon?: any;
    passiveIcon?: any;
    color?: string;
    orientation?: any;
}

interface IProps {
    activeTabIndex: number;
    onChange: (event: any, activeTabIndex: any) => void;
    tabList: Array<ITab>;
    iconShow?: boolean;
    indicatorColor?: string;
    textColor?: string;
    children?: React.ReactNode;
    orientation?: any;
    href?: string;
}

export const SCUITabs: FC<IProps> = ({
    activeTabIndex = 0,
    onChange,
    tabList,
    iconShow = true,
    children,
    orientation = 'horizontal',
}) => {
    const getIcon = (tabInfo: any): any => {
        if (!Helper.isUndefined(tabInfo.activeIcon) && !Helper.isUndefined(tabInfo.passiveIcon)) {
            return activeTabIndex > tabInfo.id ? (
                <tabInfo.passiveIcon color={tabInfo.passiveColor} />
            ) : (
                <tabInfo.activeIcon color={tabInfo.activeColor} />
            );
        }
    };

    const _onChangeTab = (event: any, activeIndexTab: number) => {
        let result = -1;

        if (onChange) {
            if (Array.isArray(activeIndexTab) && activeIndexTab.length > 0) {
                result = activeIndexTab[0];
            } else {
                result = activeIndexTab;
            }
            onChange(event, result);
        }
    };

    return (
        <Grid container className={'sc-tabs'} spacing={2}>
            <Grid
                className="sc-tabs"
                size={{
                    xs: 12,
                }}
            >
                <Box
                    sx={{
                        borderBottom: orientation === 'vertical' ? 0 : 2,
                        borderColor: 'divider',
                    }}
                >
                    <Tabs
                        value={activeTabIndex}
                        onChange={_onChangeTab}
                        indicatorColor={'primary'}
                        textColor={'primary'}
                        scrollButtons={'auto'}
                        variant={'scrollable'}
                        orientation={orientation}
                    >
                        {tabList.map(
                            (tabInfo: any) =>
                                (tabInfo.isShow == null || tabInfo.isShow === true) && (
                                    <Tab
                                        href={tabInfo.href}
                                        key={tabInfo.id}
                                        value={tabInfo.id}
                                        icon={
                                            iconShow &&
                                            Object.prototype.hasOwnProperty.call(tabInfo, 'activeIcon') &&
                                            tabInfo?.activeIcon !== null ? (
                                                <IconButton size="large">{getIcon(tabInfo)}</IconButton>
                                            ) : (
                                                ''
                                            )
                                        }
                                        label={tabInfo.name}
                                    />
                                )
                        )}
                    </Tabs>
                </Box>
            </Grid>
            <Grid
                size={{
                    xs: 12,
                }}
            >
                {children}
            </Grid>
        </Grid>
    );
};
